// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
  width: 1400px;
}

.content-container { 
  display: flex;
  justify-content: flex-start; 
  margin: 120px auto 0;
  padding: 10px;
  position: relative;
  width: 1400px;
}`, "",{"version":3,"sources":["webpack://./src/Layouts/Main/Main.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".main-container {\n  margin: 0 auto;\n  min-height: 100vh;\n  position: relative;\n  width: 1400px;\n}\n\n.content-container { \n  display: flex;\n  justify-content: flex-start; \n  margin: 120px auto 0;\n  padding: 10px;\n  position: relative;\n  width: 1400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
